module.exports = {"data":{"allMarkdownRemark":{"totalCount":1,"edges":[{"node":{"fields":{"slug":"/leads-program/"},"frontmatter":{"title":"LEADS and Associated Services","subTitle":"In addition to a law enforcement assisted diversion program, a Resource Navigator helped individuals successfully transition back to the community.","date":"2018-10-09","category":"Policing"}}}]}},"pathContext":{"posts":[{"title":"LEADS and Associated Services","slug":"/leads-program/"}],"tagName":"Diversion","tagCount":1}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/tags-diversion.json
// module id = 1285
// module chunks = 190519597166818